import { registerPwa } from '../../common/utils/pwaRuntime'
registerPwa()
/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueAnalytics from 'vue-analytics'
import qs from 'qs';
import "babel-polyfill"
import Cookies from 'js-cookie';
import NProgress  from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/common/store/';
import i18n from './i18n/i18n'

import './style/iconfont/iconfont.css'
import './style/iconfont2/iconfont.css'

// ui 组件样式
import 'swiper/dist/css/swiper.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'vant/lib/index.css'
import '@/common/rem/rem.js'
import '@/common/style/base.css'

NProgress.configure({
  easing: 'ease',  // 动画方式
  speed: 500,  // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})


// api.defaults.headers.common['Authentication-Token'] = store.state.token;
Vue.config.productionTip = false;
// 拓展自写方法
Vue.prototype.$Cookies = Cookies;

Vue.prototype.$project = '902';

// 全局过滤器
// import * as filters from '@/common/filter/index.js'
// Object.keys(filters).forEach(key=>{
//     Vue.filter(key,filters[key])//插入过滤器名和对应方法
// })
// 全局过滤器
import { switchCase, toFixed, strEncryption } from '@/common/filter/index.js'
import { parseTime } from '@/common/utils/Date.js'
Vue.filter("switchCase", switchCase)
Vue.filter("ToFixed", toFixed)
Vue.filter("strEncryption", strEncryption)
Vue.filter("parseTime", parseTime)


// 自写ui组件设为公共
import GL_Component from "./utils/globalComponent.js"
Vue.use(GL_Component);

// 按需引入通用ui
import GL_ui from "./utils/global-ui.js"
Vue.use(GL_ui)

import limitNum from '@/common/directive/onlyNum'
Vue.directive('limitNum', limitNum)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
});
// 加入百度统计
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})

router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/pages/build902/build902.js